import { DeleteScenarioResponse } from "@mutiny-group/sbo-openapi-client";

import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

export const deleteScenarioV2 = (
  scenarioBuilderClient: ScenarioBuilderClient,
  scenarioId: string
): Promise<DeleteScenarioResponse> => {
  return scenarioBuilderClient.scenarios.deleteScenario({
    scenarioUuid: scenarioId,
  });
};
